import loadMoreResourcesSlice from 'utils/RestSlice/slices/loadMoreResourcesSlice';

import bulkResourcesActionSlice from './bulkResourcesActionSlice';
import createResourceSlice from './createResourceSlice';
import deleteResourceSlice from './deleteResourceSlice';
import loadResourceSlice from './loadResourceSlice';
import loadResourcesSlice from './loadResourcesSlice';
import resetResourceSlice from './resetResourceSlice';
import resetResourcesSlice from './resetResourcesSlice';
import updateResourceSlice from './updateResourceSlice';

export {
  bulkResourcesActionSlice,
  createResourceSlice,
  deleteResourceSlice,
  loadMoreResourcesSlice,
  loadResourceSlice,
  loadResourcesSlice,
  resetResourceSlice,
  resetResourcesSlice,
  updateResourceSlice,
};



// WEBPACK FOOTER //
// ./src/utils/RestSlice/slices/index.js